import ModalComponent from '@components/common/Modal';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  getDetailOfOrder,
  updateOpenCreateModal,
  updateOpenCreateOrderModal,
  updateReqReGetOrder
} from '@slice/orderManager.slice';
import { Button, Divider, message, Modal, Spin, Table, Tooltip } from 'antd';
import { RootState } from 'app/store';
import Helpers from 'helpers/Helpers';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { resetState, updatePageLoadingApi } from '@slice/select.slice';
import OrderManagerApi, { TTypeStatusAPI } from 'apis/api/OrderManager';
import { TTypeStatusMsg } from '@models/OrderManager';
import dayjs from 'dayjs';
import { updateCustomerSelect } from '@slice/createOrder.slice';
import { layGiaTriTienHienThi, LOAI_TIEN } from 'helpers/ConfigTheoRole';
import { isNeedRequestUpdateMsg, resolveRequestUpdateSource } from '../common/Hooks/hook/upgradeOrder';
import { confirmRequestUpdate } from '../common/confirmRequestUpdate';
import { buildThuNoXacNhan, modeToCheDo, THU_NO_NHAP_THEM } from '../common/Hooks/hook/thuNoAllocation';
import { ThuNoXacNhan } from '../layoutContentUWR/ThuNoXacNhan';

type PaymentWarningResult = {
  htttLabel: string | undefined;
  showWarningTienMat: boolean;
  showWarningTienChuyenKhoan: boolean;
};

// function getPaymentWarning(params: {
//   isKeToanThuTienMat?: boolean;
//   hinhThucThanhToan?: string;
//   tienThucThu?: number | string;
//   tienChuyenKhoanThucTe?: number | string;
// }): PaymentWarningResult {
//   const { isKeToanThuTienMat, hinhThucThanhToan, tienThucThu, tienChuyenKhoanThucTe } = params;
//   const htttLabel = isKeToanThuTienMat ? 'KToán Thu TM' : hinhThucThanhToan;
//   const showWarningTienMat = htttLabel === 'Tiền mặt' && (!tienThucThu || Number(tienThucThu) === 0);
//   const showWarningTienChuyenKhoan =
//     htttLabel === 'Chuyển khoản' && (!tienChuyenKhoanThucTe || Number(tienChuyenKhoanThucTe) === 0);

//   return { htttLabel, showWarningTienMat, showWarningTienChuyenKhoan };
// }

function getPaymentWarning(params: {
  isKeToanThuTienMat?: boolean;
  hinhThucThanhToan?: string;
  tienThucThu?: number | string;
  tienChuyenKhoanThucTe?: number | string;
  keyOrder?: number | string;
}): PaymentWarningResult {
  const { isKeToanThuTienMat, hinhThucThanhToan, tienThucThu, tienChuyenKhoanThucTe, keyOrder } = params;
  const htttLabel = isKeToanThuTienMat ? 'KToán Thu TM' : hinhThucThanhToan;
  const showWarningTienMat = htttLabel === 'Tiền mặt' && (!tienThucThu || Number(tienThucThu) === 0);
  const showWarningTienChuyenKhoan =
    htttLabel === 'Chuyển khoản' &&
    (!tienChuyenKhoanThucTe || Number(tienChuyenKhoanThucTe) === 0) &&
    ![11, 12, 13].includes(Number(keyOrder));

  return { htttLabel, showWarningTienMat, showWarningTienChuyenKhoan };
}

type IConfirmOrders = {
  resetAllForm?: () => any;
  // clickSubmitForm?: () => any;
  callBackCloseModal?: () => any;
  // form?: FormInstance<any> | undefined;
  setConfirmLoading?: (value?: boolean) => any;
  typeOrder?: string;
  callBackConfirm?: () => any;
  setCustomerCode?: any;
};

export default function ConfirmOrderModal(props: IConfirmOrders) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const openCodeCreateModal = useSelector((state: RootState) => state.orderManager.openCodeCreateModal);
  const createOrders = useSelector((state: RootState) => state.orderManager.createOrders);
  const [arrayBS, setArrayBS] = useState<any[]>([]);
  // Thêm vào trong component của bạn
  const [isProcessing, setIsProcessing] = useState(false);

  const uLogin = useSelector((state: RootState) => state.user.account);
  const canViewPrice = !!uLogin?.ActionOrder?.viewPrice; // quyền xem giá tiền

  const userAnTien = useSelector((state: RootState) => state.user.userAnTien);

  const httt = createOrders['rowSelected']?.payment?.hinhThucThanhToan;

  const htttBody = createOrders['dataBody']?.hinhThucThanhToan;

  // Ẩn dòng "Tiền chuyển khoản thực tế" với đơn loại 11, 12, 13
  const keyOrderValue = Number(
    createOrders?.keyOrder ?? createOrders['rowSelected']?.orderType?.id ?? createOrders['dataBody']?.orderTypeId
  );
  const isHideTienChuyenKhoan = [11, 12, 13].includes(keyOrderValue);

  // ------------ Cảnh báo: từng kiểu HTTT  nhưng tương ứng tiền thu được lại = 0 ------------ ///

  const dataBody = createOrders['dataBody']; // lấy từ dataBody
  const rowSelected = createOrders['rowSelected']; // lấy từ rowSelected
  const productSetDataHaveDetails = useSelector((state: RootState) => state.createOrder.productSetDataHaveDetails);

  // gọi hàm chec cho lẹ
  const {
    showWarningTienMat: showWarningTienMatDataBody,
    showWarningTienChuyenKhoan: showWarningTienChuyenkhoanDataBody
  } = getPaymentWarning({
    isKeToanThuTienMat: dataBody?.isKeToanThuTienMat,
    hinhThucThanhToan: dataBody?.hinhThucThanhToan,
    tienThucThu: dataBody?.tienThucThu,
    tienChuyenKhoanThucTe: dataBody?.tienChuyenKhoanThucTe,
    keyOrder: createOrders?.keyOrder
  });

  // gọi hàm check cho lọi rowselect
  const {
    showWarningTienMat: showWarningTienMatRowSelected,
    showWarningTienChuyenKhoan: showWarningTienChuyenkhoanRowSelected
  } = getPaymentWarning({
    isKeToanThuTienMat: rowSelected?.isKeToanThuTienMat,
    hinhThucThanhToan: rowSelected?.payment?.hinhThucThanhToan,
    tienThucThu: rowSelected?.payment?.tienThucThu,
    tienChuyenKhoanThucTe: rowSelected?.payment?.tienChuyenKhoanThucTe,
    keyOrder: createOrders?.keyOrder
  });

  ///--------------- Kết thúc rồi đây----------- ///

  const khacChiNhanh =
    createOrders['rowSelected']?.branchInfo?.isSwitchBranch &&
    (uLogin?.listBranchManage?.includes(createOrders['rowSelected']?.branchInfo?.id) ||
      uLogin?.companyBranchId === createOrders['rowSelected']?.branchInfo?.id);

  const isHiddenTienChiNhanhKhac = userAnTien
    ? false
    : ['BranchManager', 'Accountant']?.includes(uLogin?.role) && khacChiNhanh && httt === 'Nợ';

  const renderMoneyThanhToan = (value: any) =>
    Helpers.FormatMoney(
      isHiddenTienChiNhanhKhac
        ? 0
        : layGiaTriTienHienThi(
            value,
            uLogin?.role,
            createOrders?.keyOrder || createOrders['rowSelected']?.orderType?.id,
            LOAI_TIEN.TIEN_THANH_TOAN,
            httt
          ) || 0
    );

  const renderMoneyThucThu = (value: any) =>
    Helpers.FormatMoney(
      isHiddenTienChiNhanhKhac
        ? 0
        : layGiaTriTienHienThi(
            value,
            uLogin?.role,
            createOrders?.keyOrder || createOrders['rowSelected']?.orderType?.id,
            LOAI_TIEN.TIEN_THUC_THU,
            httt
          ) || 0
    );

  const itemTypeCoop = useSelector((state: RootState) => state.select.typeCoopData);
  useEffect(() => {
    if (uLogin?.ActionOrder?.permissionsCheckTrungBS) {
      try {
        const bodyReq =
          fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
          fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành'
            ? createOrders['dataBody'].errors
            : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Nâng cấp'
            ? createOrders['dataBody']?.summaries
            : createOrders['dataBody']?.items;

        const orderTypeId = createOrders['dataBody'].orderTypeId;
        const listBs = [];

        for (let i = 0; i < bodyReq.length; i++) {
          if (bodyReq[i].oldRegistrationPlate && bodyReq[i].newRegistrationPlate) {
            listBs.push(bodyReq[i].oldRegistrationPlate?.trim(), bodyReq[i].newRegistrationPlate?.trim());
          } else if (bodyReq[i].oldRegistrationPlate) {
            listBs.push(bodyReq[i].oldRegistrationPlate?.trim());
          } else if (bodyReq[i].newRegistrationPlate) {
            listBs.push(bodyReq[i].newRegistrationPlate?.trim());
          } else if (bodyReq[i].bs) {
            listBs.push(bodyReq[i].bs?.trim());
          } else {
            listBs.push(bodyReq[i].registrationPlate?.trim());
          }
        }

        const listCheckBienSo = [{ listBs, orderType: orderTypeId }];
        if (bodyReq && uLogin?.ActionOrder?.createOrder) {
          setConfirmLoading(true);
          OrderManagerApi.CheckTrungBS({ listCheckBienSo }).then(res => {
            if (!res.data.error) {
              setArrayBS(res.data.data);
            } else {
              message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
            }
            setConfirmLoading(false);
          });
        }
      } catch (error) {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
        setConfirmLoading(false);
      }
    } else {
      return;
    }
  }, [createOrders]);

  const [isPlateListOpen, setIsPlateListOpen] = useState(false);

  // Helper dùng chung: nếu không có quyền, luôn trả 0 (định dạng tiền)
  const renderMoney = (value: any) => Helpers.FormatMoney(value || 0);
  // Helper cho các cột hiển thị số thô (VAT %, không phải tiền) — vẫn giữ nguyên logic cũ, KHÔNG cần ẩn theo canViewPrice trừ khi bạn muốn ẩn cả %VAT
  const productCategoryPMP = useSelector((state: RootState) => state.createOrder.listProductMixDataPaging);
  const productCategoryPMS = useSelector((state: RootState) => state.createOrder.dataProductMixSearch);
  const [order, setOrder] = useState<any>(); // các đơn còn lại
  const [heigth, setHeigth] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setHeigth(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const convertOrder = (detail, text) => {
    if (text === 'tp') {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];
      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPham + item.cost + item.bs,
        child: {
          ...item
        }
      }));

      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());

      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPham);

          if (findPM?.input === 0) {
            obj.child[0]['tienSP'] =
              (obj.child[0]['amount'] || 0) +
              (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0)) *
                ((obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) &&
                obj.child[0]?.cost != findPM?.giaBanSi &&
                (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham)
                  ? obj.child[0]?.cost
                  : findPM?.giaBanSi);
            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] =
              (obj.child[0]['amount'] || 0) + (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0));
            obj.child[0]['spTP'] = obj.child[0]['type'] === 0 ? 1 : 0;
            obj.child[0]['cost'] =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) &&
              obj.child[0]?.cost != findPM?.giaBanSi &&
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham)
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPham;
            obj.child[0]['cameraCount'] = obj.child[0]?.isCamera ? obj.child[0]?.cameraCount : 0;
            obj.child[0]['servicePackName'] = obj.child[0]?.isCamera ? obj.child[0]?.servicePackName : 0;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];
              tempList.push({
                ...[...mergeList.values()][i].child[j],
                cameraCount: dtl.isCamera ? dtl.cameraCount : 0,
                servicePackName: dtl.isCamera ? dtl.servicePackName : 0,
                tienSP: dtl.type !== 0 ? +dtl.cost : '',
                spTP: dtl.type === 0 ? 1 : 0,
                preMaSanPham: dtl?.maSanPham,
                isRequireSP: findPM?.input || 0
              });
            }
          }
        }
      }

      return tempList || [];
    } else if (text === 'taodontp') {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];
      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPham + item.cost + item.bs,
        child: {
          ...item
        }
      }));

      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());

      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPham);

          if (findPM?.input === 0) {
            obj.child[0]['tienSP'] =
              (obj.child[0]['amount'] || 0) *
              ((obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) &&
              obj.child[0]?.cost != findPM?.giaBanSi &&
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham)
                ? obj.child[0]?.cost
                : findPM?.giaBanSi);
            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] = obj.child[0]['amount'] || 0;
            obj.child[0]['spTP'] = !obj.child[0]['amount'] || obj.child[0]['amount'] === 0 ? 1 : 0;
            obj.child[0]['cost'] =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) &&
              obj.child[0]?.cost != findPM?.giaBanSi &&
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham)
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPham;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];
              tempList.push({
                ...[...mergeList.values()][i].child[j],
                cameraCount: dtl.isCamera ? dtl.cameraCount : 0,
                servicePackName: dtl.isCamera ? dtl.servicePackName : 0,
                tienSP: dtl.amount ? dtl.cost : '',
                spTP: !dtl.amount ? 1 : 0,
                preMaSanPham: dtl?.maSanPham,
                isRequireSP: findPM?.input || 0
              });
            }
          }
        }
      }

      return tempList || [];
    } else {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];

      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPhamMoi + item.cost + item.registrationPlate,
        child: {
          ...item
        }
      }));

      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());
      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPhamMoi);

          if (findPM?.input === 0) {
            const listID: any = [...mergeList.values()][i]?.child.map(ch => ch.id || 0);
            const costValue =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) &&
              obj.child[0]?.cost != findPM?.giaBanSi &&
              (obj.child[0]?.maSanPhamMoi == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham)
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;

            const vatValue =
              obj.child[0]?.vatValue !== null && obj.child[0]?.vatValue !== undefined && obj.child[0]?.vatValue !== 0
                ? obj.child[0]?.vatValue
                : findPM?.vatValue;

            obj.child[0]['ids'] = [...listID, ...([...mergeList.values()][i]?.child[0]['ids'] || [])].filter(function (
              item,
              index,
              arr
            ) {
              return arr.indexOf(item) === index;
            });

            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] =
              (obj.child[0]['amount'] || 0) + (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0));
            obj.child[0]['cost'] = +costValue;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPhamMoi;
            obj.child[0]['vatValue'] = vatValue || 0;
            obj.child[0]['priceAfterVat'] = +costValue + (+costValue * +vatValue) / 100 || 0;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];

              const costValue =
                !dtl.old && !uLogin.ActionOrder.editWillPay
                  ? 0
                  : (dtl?.cost === null || dtl?.cost !== undefined || dtl?.cost == 0) &&
                    dtl?.cost != findPM?.giaBanSi &&
                    (dtl?.maSanPhamMoi == dtl?.preMaSanPham || !dtl?.preMaSanPham)
                  ? dtl?.cost
                  : findPM?.giaBanSi;

              const vatValue =
                dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
                  ? dtl?.vatValue
                  : findPM?.vatValue;

              tempList.push({
                ...[...mergeList.values()][i].child[j],
                cost: costValue,
                preMaSanPham: dtl?.maSanPhamMoi,
                isRequireSP: findPM?.input || 0,

                vatValue: vatValue || 0,
                priceAfterVat: +costValue + (+costValue * +vatValue) / 100 || 0
              });
            }
          }
        }
      }

      return tempList || [];
    }
  };

  useEffect(() => {
    const data = createOrders['dataBody'];
    const row = createOrders['rowSelected'];
    const orderTypeId = Number(data?.orderTypeId);

    if (data) {
      if (data.detailItems) return setOrder(proccessProductUG(data.detailItems, true, orderTypeId));
      if (orderTypeId === 15) return setOrder([data]);
      if (data.ThuNoItems) return setOrder(proccessProductUG(data.ThuNoItems, true, orderTypeId));
      if (data.summaries) return setOrder(proccessProductUG(data.summaries, true, orderTypeId));
      if (data.diff) return setOrder(proccessProductChenhLech(data.diff));
      if (data.items) {
        const isSpecialType = orderTypeId === 3;
        const processedItems = isSpecialType ? convertOrder(data.items, 'taodontp') : data.items;
        return setOrder(proccessProductUG(processedItems, isSpecialType));
      }
      if (data.errors) return setOrder(proccessProductUG(data.errors));
      return;
    }

    if (row) {
      if (row.orderDetails) return setOrder(proccessProductUG(row.orderDetails));
      if (row.ThuNoItems) return setOrder(proccessProductUG(row.ThuNoItems, true, row.orderType.id));
      if (row.debtOrderDetails) return setOrder(proccessProductUG(row.debtOrderDetails));
      if (row.errorList) return setOrder(proccessProductUG(row.errorList));
      if (row.detailItems) return setOrder(proccessProductUG(row.detailItems));
      if (row.itemDetails) return setOrder(proccessProductUG(gomSLHangGui(row.itemDetails)));
      if (row.upgradeDetails) return setOrder(proccessProductUG(convertOrder(row.upgradeDetails, 'nc'), true));
      if (row.DeviceList) return setOrder(proccessProductUG(convertOrder(row.DeviceList, 'tp'), true));
    }

    if (createOrders['valueDetails']) {
      setOrder(proccessProductUG(createOrders['valueDetails']));
    }
  }, [createOrders]);

  const gomSLHangGui = (product: any[]) => {
    const listProMix = [...productCategoryPMP, ...productCategoryPMS];
    const arr = [];
    for (let i = 0; i < product.length; i++) {
      const findPM = listProMix.find(
        proMix =>
          proMix.maSanPham == product[i]?.maSanPhamMoi ||
          proMix.maSanPham == product[i]?.maSanPham ||
          proMix.maSanPham == product[i]?.newMaSanPham
      );
      const findPMCu = listProMix.find(
        proMix => proMix.maSanPham == product[i]?.maSanPhamCu || proMix.maSanPham == product[i]?.oldMaSanPham
      );
      arr.push({
        ...product[i],
        cost:
          (product[i]?.cost == undefined || product[i]?.cost == null) &&
          product[i]?.cost != 0 &&
          product[i]?.maSanPhamMoi != product[i]?.preMaSanPham
            ? findPM?.giaBanSi
            : product[i]?.cost,
        tenSanPham: findPM?.nameDisplay,
        tenSanPhamCu: findPMCu?.nameDisplay,
        preMaSanPham: product[i]?.maSanPhamMoi,
        isRequireSP: findPM?.input || 0
      });
    }
    return (
      arr.reduce((acc, curr) => {
        const supplieruuid = curr['tenSanPham'];
        const objInAcc = acc.find(o => o.title === supplieruuid);
        if (objInAcc) objInAcc.data.push(curr);
        else acc.push({ title: supplieruuid, data: [curr] });
        return acc;
      }, []) || []
    );
  };

  const proccessProductChenhLech = (product: any[], removeDup?: boolean, type?: number) => {
    if (!product) return [];

    return (
      product.map(dtl => {
        return {
          ...dtl
        };
      }) || []
    );
  };

  const proccessProductUG = (product: any[], removeDup?: boolean, type?: number) => {
    if (type === 12) {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];

      if (!product) return [];

      let processedList = product;

      if (removeDup) {
        processedList = product.reduce((acc: any[], item: any) => {
          const maSP = item.maSanPham || '';
          const tenSP = item.tenSanPham || '';
          const maBo = item.maBo || '';
          const cost = item.cost || 0;
          const key = `${maSP}-${tenSP}-${maBo}-${cost}`;

          const existingItem = acc.find(obj => {
            const objKey = `${obj.maSanPham || ''}-${obj.tenSanPham || ''}-${obj.maBo || ''}-${obj.cost || 0}`;
            return objKey === key;
          });

          const isIdentify = (item.phone && item.phone !== '') || (item.serial && item.serial !== '');
          const currentQty = isIdentify ? 1 : Number(item.quantity) || 1;

          if (existingItem) {
            existingItem.quantity = (Number(existingItem.quantity) || 0) + currentQty;

            if (item.phone)
              existingItem.phone = existingItem.phone ? `${existingItem.phone}, ${item.phone}` : item.phone;
            if (item.serial)
              existingItem.serial = existingItem.serial ? `${existingItem.serial}, ${item.serial}` : item.serial;
          } else {
            acc.push({
              ...item,
              quantity: currentQty
            });
          }

          return acc;
        }, []);
      }

      return (
        processedList.map(dtl => {
          const findPM = listProMix.find(
            proMix =>
              proMix.maSanPham == dtl?.maSanPhamMoi ||
              proMix.maSanPham == dtl?.maSanPham ||
              proMix.maSanPham == dtl?.newMaSanPham
          );

          const findPMCu = listProMix.find(
            proMix => proMix.maSanPham == dtl?.maSanPhamCu || proMix.maSanPham == dtl?.oldMaSanPham
          );

          const costValue =
            (dtl?.cost === undefined || dtl?.cost === null) && dtl?.maSanPhamMoi != dtl?.preMaSanPham
              ? findPM?.giaBanSi
              : dtl?.cost;

          const vatValue =
            dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
              ? dtl?.vatValue
              : findPM?.vatValue;

          return {
            ...dtl,
            cost: costValue || 0,
            totalCost: dtl?.cost * dtl?.quantity,
            tenSanPham: findPM?.nameDisplay || dtl?.tenSanPham,
            tenSanPhamCu: findPMCu?.nameDisplay || dtl?.tenSanPhamCu,
            preMaSanPham: dtl?.maSanPhamMoi,
            isRequireSP: findPM?.input || 0,
            vatValue: vatValue || 0,
            priceAfterVat: Number(costValue) + (Number(costValue) * Number(vatValue)) / 100 || 0
          };
        }) || []
      );
    } else if (type === 11) {
      const dataConvert = product[0].inDebtOrderCodes || [];

      const result = dataConvert
        .filter(item => item.checked === true)
        .map(item => {
          // Hàm nội bộ để xử lý gom mảng/chuỗi thành 1 chuỗi hiển thị duy nhất
          const formatDisplay = value => {
            if (!value) return '---';
            const rawStr = Array.isArray(value) ? value.join(', ') : value.toString();

            const cleanArray = Array.from(
              new Set(
                rawStr
                  .split(/[;,]/)
                  .map(s => s.trim())
                  .filter(Boolean)
              )
            );

            return cleanArray.length > 0 ? cleanArray.join(', ') : '---';
          };

          return {
            maDonHang: item.maDonHang,
            // Hiển thị biển số và serial gọn gàng trên 1 dòng
            bienSoXe: formatDisplay(item.bienSoXe),
            serial: formatDisplay(item.serial),
            thuVat: item.thuVat || 0,
            thuChenhLech: item.thuChenhLech || 0,

            // Các trường dữ liệu cũ của bạn
            tienNo: item.tongTienDonNo || item.tienNo || 0,
            tongTienDonNo: item.tongTienDonNo || item.tienNo || 0,
            goiCuoc: item.goiCuoc || 0,
            tienSanPham: item.tienSanPham || 0,
            tienPhi: item.tienPhi || 0,
            // MỚI: Tiền công — chỉ hiển thị, không cộng vào tienNo
            tienCong: item.tienCong || 0,
            staffCreate: item.staffCreate || item.nguoiTao,
            ngay: item.ngay ? item.ngay : '-',

            // Thêm thông tin bổ sung nếu cần hiển thị trên Modal
            loai: item.loai || item.orderType
          };
        });

      return result || [];
    } else {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];

      return (
        product
          ?.filter(function (item: any, index: any, arr) {
            return removeDup
              ? item.amount
                ? arr.findIndex(
                    obj2 =>
                      (obj2.maSanPham || obj2.maSanPhamMoi) + (obj2.registrationPlate || obj2.bs) + obj2.cost ===
                      (item.maSanPham || item.maSanPhamMoi) + (item.registrationPlate || item.bs) + item.cost
                  ) === index
                : true
              : true;
          })
          .map(dtl => {
            const findPM = listProMix.find(
              proMix =>
                proMix.maSanPham == dtl?.maSanPhamMoi ||
                proMix.maSanPham == dtl?.maSanPham ||
                proMix.maSanPham == dtl?.newMaSanPham
            );
            const findPMCu = listProMix.find(
              proMix => proMix.maSanPham == dtl?.maSanPhamCu || proMix.maSanPham == dtl?.oldMaSanPham
            );

            const costValue =
              (dtl?.cost == undefined || dtl?.cost == null) && dtl?.cost != 0 && dtl?.maSanPhamMoi != dtl?.preMaSanPham
                ? findPM?.giaBanSi
                : dtl?.cost;

            const vatValue =
              dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
                ? dtl?.vatValue
                : findPM?.vatValue;

            return {
              ...dtl,
              cost: costValue,
              tenSanPham: findPM?.nameDisplay,
              tenSanPhamCu: findPMCu?.nameDisplay,
              preMaSanPham: dtl?.maSanPhamMoi,
              isRequireSP: findPM?.input || 0,

              vatValue: vatValue || 0,

              priceAfterVat: +costValue + (+costValue * +vatValue) / 100 || 0
            };
          }) || []
      );
    }
  };

  // eslint-disable-next-line
  const fullTypeOrder = [
    'Hàng gửi',
    'Lắp mới',
    'Thu phí',
    'Sửa chữa',
    'Bảo hành',
    'Thu đổi',
    'Nâng cấp',
    'Tháo - Lắp lại',
    'ĐL lắp giùm',
    'Lắp giùm ĐL',
    'Thu nợ',
    'Trả hàng',
    'Chênh lệch',
    '',
    'Chiết khấu'
  ];
  const tagTLL = ['Tháo', 'Lắp lại', 'Tháo - Lắp lại'];
  const chiNhanh = ['Hồ Chí Minh', 'Cần Thơ', 'Đà Nẵng', 'Hà Nội', 'Bình Minh'];
  const handleCancel = () => {
    dispatch(updateOpenCreateModal(false));
  };

  const duplicatePlateWarning = useMemo(() => {
    if (!arrayBS?.length) return null;

    return (
      <>
        {/* Modal phụ — danh sách đơn trùng */}
        <Modal
          title={<span className="text-[13px] font-semibold">Các đơn trùng biển số ({arrayBS.length})</span>}
          visible={isPlateListOpen}
          onOk={() => setIsPlateListOpen(false)}
          onCancel={() => setIsPlateListOpen(false)}
          width={600}
          style={{ top: 20 }}
          maskClosable
        >
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            {/* Header */}
            <div
              className="grid grid-cols-[24px_120px_140px_140px_1fr] gap-3
                    border-b border-gray-200 pb-2 mb-1
                    text-[12px] uppercase tracking-wider font-medium"
            >
              <div>#</div>
              <div>Biển số</div>
              <div>Mã đơn hàng</div>
              <div>Thời gian</div>
              <div>NV tạo</div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-gray-100">
              {arrayBS.map((e, index) => (
                <div
                  key={index}
                  className="grid grid-cols-[24px_120px_140px_140px_1fr] gap-3
                     items-center py-2 text-[13px]"
                >
                  <span className="text-gray-400 text-center">{index + 1}</span>
                  <span className="font-semibold text-gray-800">{e.bs}</span>
                  <span className="font-semibold text-gray-800">{e.maDonHang}</span>
                  <span className="text-gray-500">{moment(new Date(e.thoiGianTao)).format('DD/MM/YYYY HH:mm')}</span>
                  <span className="text-gray-600">{e.staffCreate}</span>
                </div>
              ))}
            </div>
          </div>
        </Modal>

        {/* Banner cảnh báo — gọn, không expand inline */}
        <div
          className="mb-3 flex items-center gap-2.5 rounded-lg
                      border border-orange-300 bg-orange-50 px-3 py-2"
        >
          {/* Icon nhỏ */}
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#f97316"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>

          {/* Text */}
          <span className="flex-1 text-[12px]">
            Biển số{' '}
            <span
              className="mx-0.5 rounded bg-orange-100 px-1.5 py-0.5
                           text-[13px] font-semibold text-orange-800"
            >
              {arrayBS[0]?.bs}
            </span>{' '}
            đã tồn tại trong <span className="font-semibold">{arrayBS.length} đơn hàng</span> khác. Bạn có muốn tiếp tục
            tạo mới?
          </span>

          {/* Nút xem chi tiết */}
          {arrayBS.length > 0 && (
            <button
              className="flex-shrink-0 rounded border border-orange-300 bg-white
                       px-2.5 py-1 text-[13px] font-medium
                       hover:bg-orange-50 hover:border-orange-400 transition-colors"
              onClick={() => setIsPlateListOpen(true)}
            >
              Xem chi tiết
            </button>
          )}
        </div>
      </>
    );
  }, [arrayBS, isPlateListOpen]);

  const renderListOrder = useMemo(() => {
    const columnsTD = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'quantity'
      }
    ];
    const columns = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Serial',
        dataIndex: 'serial',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phone',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'amount'
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsHG = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'title',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'data',
        render: text => <span>{!text ? '-' : text?.length}</span>
      }
    ];
    const columnsTH = [
      {
        title: 'Mã trang ',
        dataIndex: 'oldCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe ',
        dataIndex: 'oldDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số ',
        dataIndex: 'oldRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{renderMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];

    const columnsTL = [
      {
        title: 'Mã trang mới',
        dataIndex: 'newCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe mới',
        dataIndex: 'newDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số mới',
        dataIndex: 'newRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{renderMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsTLL = [
      {
        title: 'Mã trang',
        dataIndex: 'oldCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'oldDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'oldRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã trang mới',
        dataIndex: 'newCompanyId'
      },
      {
        title: 'Đội xe mới',
        dataIndex: 'newDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số mới',
        dataIndex: 'newRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{renderMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsSC = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Mã thiết bị',
        dataIndex: 'tenSanPhamCu',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã thiết bị mới',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Lỗi ghi nhận',
        dataIndex: 'errorTpye',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá thiết bị',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsTP = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'bs',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã sản phẩm',
        dataIndex: 'maSanPham'
      },
      {
        title: 'Tiền phí & Tiền SP',
        dataIndex: 'cost',
        render: text => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Gói cước',
        dataIndex: 'servicePackName',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng cam',
        dataIndex: 'cameraCount'
      },
      {
        title: 'Số lượng SP',
        dataIndex: 'amount',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Tổng tiền SP',
        dataIndex: 'tienSP',
        render: (text, record) => {
          if (!canViewPrice) return <span>{renderMoney(0)}</span>;
          return (
            <span>{!text && record.spTP === 1 ? '–' : !text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
          );
        }
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsNC = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Mã thiết bị cũ',
        dataIndex: 'tenSanPhamCu',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã thiết bị mới',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'amount',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{renderMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];
    const columnsDLLG = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{!canViewPrice ? 0 : vatValue !== '' && vatValue !== undefined ? text : 0}</span>;
        }
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => {
          const vatValue = createOrders['dataBody']?.orderVat?.vatValue ?? createOrders['body']?.orderVat?.vatValue;
          return <span>{renderMoney(vatValue !== '' && vatValue !== undefined ? text : 0)}</span>;
        }
      }
    ];

    const columnsTHang = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng SP',
        dataIndex: 'quantity',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Tiền SP',
        dataIndex: 'cost',
        render: (text, record) => {
          if (!canViewPrice) return <span>{renderMoney(0)}</span>;
          return (
            <span>{!text && record.spTP === 1 ? '–' : !text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
          );
        }
      },
      {
        title: 'Tổng tiền',
        dataIndex: 'totalCost',
        render: (text, record) => <span>{renderMoney(text)}</span>
      }
    ];

    const columnsThuNo = [
      {
        title: 'Mã đơn hàng',
        dataIndex: 'maDonHang',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại đơn',
        dataIndex: 'loai',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Phụ thu',
        dataIndex: 'thuVat',
        // Gộp VAT + Chênh lệch + Gói cước — hover xem chi tiết breakdown, đồng bộ với OrderDetailThuNo
        render: (text, record) => {
          const vat = record.thuVat || 0;
          const chenhLech = record.thuChenhLech || 0;
          const goiCuoc = record.goiCuoc || 0;
          const tongPhuThu = vat + chenhLech + goiCuoc;
          return (
            <Tooltip
              title={
                <div className="flex flex-col gap-0.5 text-[11px]">
                  <span>VAT: {Helpers.FormatMoney(vat)}</span>
                  <span>Chênh lệch: {Helpers.FormatMoney(chenhLech)}</span>
                  <span>Gói cước: {Helpers.FormatMoney(goiCuoc)}</span>
                </div>
              }
            >
              <span className="cursor-help border-b border-dashed border-gray-400">{renderMoney(tongPhuThu)}</span>
            </Tooltip>
          );
        }
      },
      {
        title: 'Tiền SP',
        dataIndex: 'tienSanPham',
        render: (text, record) => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Tiền phí',
        dataIndex: 'tienPhi',
        render: (text, record) => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Tiền công',
        dataIndex: 'tienCong',
        render: (text, record) => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Tiền nợ',
        dataIndex: 'tienNo',
        render: (text, record) => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Người tạo',
        dataIndex: 'staffCreate'
      },
      {
        title: 'TG hoàn thành',
        dataIndex: 'ngay'
      }
    ];

    const columnsChenhLech = [
      {
        title: 'Số hóa đơn',
        dataIndex: 'soHoaDon'
      },
      {
        title: 'Tiền chênh lệch',
        dataIndex: 'thuChenhLech',
        render: (text, record) => {
          return <span> {!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      }
    ];

    const columnsCK = [
      {
        title: 'Mã KH nhận CK',
        dataIndex: 'targetCustomerCode',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Tên KH',
        dataIndex: 'targetCustomerName',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'SĐT',
        dataIndex: 'targetCustomerPhone',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Ngân hàng',
        dataIndex: 'bankName',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số tài khoản',
        dataIndex: 'bankAccount',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Công nợ hiện tại',
        dataIndex: 'currentDebt',
        render: text => <span>{renderMoney(text)}</span>
      },
      {
        title: 'Tiền chiết khấu',
        dataIndex: 'discountAmount',
        render: text => <span>{renderMoney(text)}</span>
      }
    ];

    // Đơn thu nợ bản mới: form xác nhận chỉ thông tin tiền (bỏ VAT, loại hình hợp tác, bảng sản phẩm)
    if (THU_NO_NHAP_THEM && !createOrders['body'] && createOrders?.keyOrder === 11) {
      const body = createOrders['dataBody'] || {};
      return (
        <div className="p-3 border rounded-lg bg-white">
          <ThuNoXacNhan
            khachHang={body.customerName}
            soDienThoai={body.customerPhone}
            hinhThucThanhToan={body.isKeToanThuTienMat ? 'KToán Thu TM' : body.hinhThucThanhToan}
            noiDungChuyenKhoan={body.noiDungChuyenKhoan}
            cheDo={modeToCheDo(body.debtAllocationMode) ?? 'auto'}
            data={buildThuNoXacNhan({
              items: body.ThuNoItems || [],
              tienThucNhan: body.tienKhoan,
              duNoDung: body.duNoKhachHang,
              phuPhi: 0, // màn tạo không có phụ phí (tongTienOptions luôn 0)
              chiTiet: {
                thuCongNoThietBi: Number(body.thuCongNoThietBi || 0),
                thuVat: Number(body.thuVat || 0),
                thuChenhLech: Number(body.thuChenhLech || 0),
                thuGoiCuoc: Number(body.thuGoiCuoc || 0),
                tienPhi: Number(body.tienPhi || 0),
                tienCong: Number(body.tienCong || 0)
              },
              allocation: body.listPaymentAllocations?.[0] || null
            })}
          />
        </div>
      );
    }

    if (!createOrders['body']) {
      return (
        <div>
          <div className="p-3 bg-gray-50 rounded-t-lg border border-b-0 text-[13px]">
            <div className="grid grid-cols-4 gap-4 mb-3 pb-2 border-b border-gray-200">
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TypeOrder')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] === 'Tháo - Lắp lại'
                    ? `${fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1]} (${
                        tagTLL[Number(createOrders['dataBody']?.thaoLapTag) - 1]
                      })`
                    : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1]}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.BranchWork')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {chiNhanh[Number(createOrders['chiNhanh']) - 1] || ''}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TimeDeli')}
                </div>
                <div className="font-semibold">
                  {createOrders?.keyOrder !== 12 && createOrders?.keyOrder !== 13
                    ? moment(new Date(createOrders['dataBody']?.thoiGianHenLap || ''))
                        .subtract(7, 'hours')
                        .format('HH:mm DD/MM/YYYY')
                    : '--'}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.CoopType')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {itemTypeCoop?.find(i => i.value === createOrders?.['dataBody']?.cooperationTypeId)?.label || ''}
                </div>
              </div>
            </div>

            {/* Hàng 2: Khách hàng & Tài chính (Chia 4 cột) */}
            <div className="grid grid-cols-4 gap-6 items-start">
              {/* Thông tin KH - Chiếm 2 cột đầu */}
              <div className="col-span-2 grid grid-cols-2 gap-y-1 gap-x-4 border-r pr-4">
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCus')}: </span>
                  <span>{createOrders['dataBody']?.customerName || ''}</span>
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCus')}: </span>
                  <span className="text-red-500">{createOrders['dataBody']?.customerPhone || ''}</span>
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCusLH')}: </span>
                  <span>{createOrders['dataBody']?.tenNguoiLienHe || ''}</span>
                </div>
                <div className="col-span-1">
                  {createOrders['dataBody']?.sdtLienHe && (
                    <>
                      <span className="font-semibold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCusLH')}:{' '}
                      </span>
                      <span className="text-red-500">{createOrders['dataBody']?.sdtLienHe}</span>
                    </>
                  )}
                </div>
                <div className="col-span-2 mt-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Address')}: </span>
                  <span className="text-gray-600 italic">{createOrders['dataBody']?.orderAddress?.address || ''}</span>
                </div>
              </div>

              {/* Phương thức & Giao dịch - Cột 3 */}
              <div className="col-span-1 space-y-2">
                <div>
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Method')}: </span>
                  <span className="text-red-600 font-medium uppercase">
                    {createOrders['dataBody']?.isKeToanThuTienMat
                      ? 'KToán Thu TM'
                      : createOrders['dataBody']?.hinhThucThanhToan || ''}
                  </span>
                </div>
                {createOrders?.keyOrder !== 11 && (
                  <div>
                    <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.VAT')}: </span>
                    <span className="text-red-600">{createOrders['dataBody']?.orderVat !== null ? 'Có' : 'Không'}</span>
                  </div>
                )}
                {createOrders?.keyOrder === 11 && (
                  <div className="bg-blue-50 p-1.5 rounded border border-blue-100 text-[12px]">
                    <div>
                      <b>{t('OrganizedSales.OrderManager.CorfirmOrder.MaGD')}:</b>{' '}
                      {createOrders['dataBody']?.ngayGiaoDich
                        ? dayjs(createOrders['dataBody']?.ngayGiaoDich).format('DD-MM-YYYY')
                        : createOrders['dataBody']?.maGiaoDich
                        ? dayjs(createOrders['dataBody']?.maGiaoDich).format('DD-MM-YYYY')
                        : ''}
                    </div>
                    <div className="truncate">
                      <b>Nội dung:</b> {createOrders['dataBody']?.noiDungChuyenKhoan}
                    </div>
                    <div className="text-orange-700 font-bold mt-1 uppercase text-[11px]">
                      {t('OrganizedSales.OrderManager.CorfirmOrder.DuNo')}:{' '}
                      {renderMoney(createOrders['dataBody']?.duNoKhachHang)}
                    </div>
                  </div>
                )}
              </div>

              {/* Tài chính tổng - Cột 4 */}
              <div className="col-span-1 bg-white p-2 rounded shadow-sm border border-gray-200 text-right">
                <div className="flex justify-between items-center">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyWill')}
                  </span>
                  <span className="text-lg font-bold text-blue-600">
                    {renderMoneyThanhToan(createOrders['dataBody']?.tienThanhToan)}
                  </span>
                </div>
                <div className="pt-1 border-t border-gray-100">
                  <div className=" flex justify-between items-center">
                    <span className="text-[10px] text-gray-400 block uppercase font-bold">
                      {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyPayed')}
                    </span>
                    <span className="text-lg font-bold text-green-600">
                      {renderMoneyThucThu(createOrders['dataBody']?.tienThucThu)}
                    </span>
                  </div>

                  {showWarningTienMatDataBody && (
                    <div className="mt-1 flex items-center justify-end gap-1 text-[11px] font-medium text-orange-600">
                      <span>⚠️</span>
                      <span className="text-left">Thanh toán tiền mặt nhưng chưa ghi nhận tiền thực thu!</span>
                    </div>
                  )}
                </div>

                {htttBody !== 'Tiền mặt' && !isHideTienChuyenKhoan && (
                  <div className="pt-1 border-t border-gray-100">
                    <div className=" flex justify-between items-center">
                      <span className="text-[10px] text-gray-400 block uppercase font-bold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyBankingPayed')}
                      </span>
                      <span className="text-lg font-bold text-red-600">
                        {renderMoneyThucThu(createOrders['dataBody']?.tienChuyenKhoanThucTe)}
                      </span>
                    </div>

                    {showWarningTienChuyenkhoanDataBody && (
                      <div className="mt-1 flex items-center justify-end gap-1 text-[11px] font-medium text-orange-600">
                        <span>⚠️</span>
                        <span className="text-left">
                          Thanh toán chuyển khoản nhưng chưa ghi nhận tiền chuyển khoản!
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Thông tin VAT (Toàn bộ chiều ngang nếu có) */}
            {createOrders['dataBody']?.orderVat?.vatValue?.mst !== '' && (
              <div className="mt-2 p-1.5 text-[12px] flex items-center space-x-3">
                {/* Nhãn tiêu đề nhỏ gọn */}
                <div className="font-bold text-red-600 uppercase whitespace-nowrap border-r border-red-200 pr-3">
                  VAT
                </div>

                {/* Nội dung trên 1 hàng */}
                <div className="flex flex-1 items-center space-x-4 overflow-hidden">
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">MST:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.vatValue?.mst}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="truncate min-w-[150px]">
                    <span className="font-semibold text-gray-500">Công ty:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.vatValue?.tenCongTy}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">Email:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.vatValue?.email}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="truncate flex-1">
                    <span className="font-semibold text-gray-500">Địa chỉ:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.vatValue?.address}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
            <h3 className="ml-1">SẢN PHẨM: </h3>
            <Table
              scroll={{ y: heigth > 899 ? 400 : 200 }}
              columns={
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Nâng cấp'
                  ? columnsNC
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'ĐL lắp giùm'
                  ? columnsDLLG
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Trả hàng'
                  ? columnsTHang
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu nợ'
                  ? columnsThuNo
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu phí'
                  ? columnsTP
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chênh lệch'
                  ? columnsChenhLech
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
                    fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành'
                  ? columnsSC
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag === 3
                  ? columnsTLL
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag == 2
                  ? columnsTL
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chiết khấu'
                  ? columnsCK
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag == 1
                  ? columnsTH
                  : columnsTD
              }
              pagination={false}
              dataSource={
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'ĐL lắp giùm' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Trả hàng' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu nợ' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chênh lệch' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu phí' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Nâng cấp' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chiết khấu' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại'
                  ? order
                  : createOrders['dataBody']?.items
              }
            ></Table>
          </div>
          <Divider className="" style={{ margin: 0, padding: '0px' }} />
        </div>
      );
    } else {
      return (
        <>
          <div className="p-3 bg-gray-50 rounded-t-lg border border-b-0 text-[13px]">
            {/* Hàng 1: Định danh đơn hàng (Dàn trải 4 cột) */}
            <div className="grid grid-cols-4 gap-4 mb-3 pb-2 border-b border-gray-200">
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TypeOrder')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {createOrders['rowSelected']?.loaiDonHang === 'Tháo - Lắp lại'
                    ? `${createOrders['rowSelected']?.loaiDonHang} (${
                        tagTLL[Number(createOrders['rowSelected']?.thaoLapTag) - 1]
                      })`
                    : createOrders['rowSelected']?.loaiDonHang}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.BranchWork')}
                </div>
                <div className="font-bold text-red-600 uppercase">{createOrders['rowSelected']?.branchName || ''}</div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TimeDeli')}
                </div>
                <div className="font-semibold">
                  {moment(new Date(createOrders['rowSelected']?.times?.thoiGianHenLap || '')).format(
                    'HH:mm DD/MM/YYYY'
                  )}
                </div>
              </div>
              <div className="text-right">
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.CoopType')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {itemTypeCoop?.find(i => i.value === createOrders?.['rowSelected']?.customerInfo?.cooperationTypeId)
                    ?.label || ''}
                </div>
              </div>
            </div>

            {/* Hàng 2: Khách hàng & Tài chính */}
            <div className="grid grid-cols-4 gap-6 items-start">
              {/* Cột 1 & 2: Thông tin khách hàng */}
              <div className="col-span-2 grid grid-cols-2 gap-y-1 gap-x-4 border-r pr-4">
                <div className="col-span-1 truncate">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCus')}: </span>
                  {createOrders['rowSelected']?.CustomerName || ''}
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCus')}: </span>
                  <span className="text-red-500">{createOrders['rowSelected']?.CusNumberPhone || ''}</span>
                </div>
                <div className="col-span-1 truncate">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCusLH')}: </span>
                  {createOrders['dataBody']?.tenNguoiLienHe || '---'}
                </div>
                <div className="col-span-1">
                  {createOrders['dataBody']?.sdtLienHe && (
                    <>
                      <span className="font-semibold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCusLH')}:{' '}
                      </span>
                      <span className="text-red-500">{createOrders['dataBody']?.sdtLienHe}</span>
                    </>
                  )}
                </div>
                <div className="col-span-2 mt-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Address')}: </span>
                  <span className="text-gray-600 italic">{createOrders['rowSelected']?.AddressShip || ''}</span>
                </div>
              </div>

              {/* Cột 3: Thanh toán & GD */}
              <div className="col-span-1 space-y-2">
                <div>
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Method')}: </span>
                  <span className="text-blue-700 font-medium">
                    {createOrders['rowSelected']?.isKeToanThuTienMat
                      ? 'KToán Thu TM'
                      : createOrders['rowSelected']?.payment?.hinhThucThanhToan || ''}
                  </span>
                </div>
                {createOrders?.keyOrder !== 11 && (
                  <div>
                    <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.VAT')}: </span>
                    <span className="font-medium">
                      {createOrders['rowSelected']?.orderVat?.tenCongTy !== '' ? 'Có' : 'Không'}
                    </span>
                  </div>
                )}
                {createOrders?.keyOrder === 11 && (
                  <div className="bg-orange-50 p-1.5 rounded border border-orange-100 text-[11px]">
                    <div>
                      <b>{t('OrganizedSales.OrderManager.CorfirmOrder.MaGD')}:</b>{' '}
                      {createOrders['rowSelected']?.ngayGiaoDich
                        ? dayjs(createOrders['rowSelected']?.ngayGiaoDich).format('DD-MM-YYYY')
                        : createOrders['rowSelected']?.maGiaoDich
                        ? dayjs(createOrders['rowSelected']?.maGiaoDich).format('DD-MM-YYYY')
                        : ''}
                    </div>
                    <div className="truncate">
                      <b>Nội dung:</b> {createOrders['rowSelected']?.noiDungChuyenKhoan}
                    </div>
                    <div className="text-red-600 font-bold mt-1">
                      DƯ NỢ: {renderMoney(createOrders['rowSelected']?.duNoKhachHang)}
                    </div>
                  </div>
                )}
              </div>

              {/* Cột 4: Box Tiền */}
              <div className="col-span-1 bg-white p-2 rounded shadow-sm border border-gray-200 text-right">
                <div className="flex justify-between items-center">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyWill')}
                  </span>
                  <span className="text-lg font-bold text-blue-600">
                    {renderMoneyThanhToan(createOrders['rowSelected']?.payment?.tienThanhToan)}
                  </span>
                </div>

                <div className="pt-1 border-t border-gray-100">
                  <div className=" flex justify-between items-center">
                    <span className="text-[10px] text-gray-400 block uppercase font-bold">
                      {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyPayed')}
                    </span>
                    <span className="text-lg font-bold text-green-600">
                      {renderMoneyThucThu(createOrders['rowSelected']?.payment?.tienThucThu)}
                    </span>
                  </div>

                  {showWarningTienMatRowSelected && (
                    <div className="mt-1 flex items-center justify-end gap-1 text-[11px] font-medium text-orange-600">
                      <span>⚠️</span>
                      <span className="text-left">Thanh toán tiền mặt nhưng chưa ghi nhận tiền thực thu!</span>
                    </div>
                  )}
                </div>

                {httt !== 'Tiền mặt' && !isHideTienChuyenKhoan && (
                  <div className="pt-1 border-t border-gray-100">
                    <div className=" flex justify-between items-center">
                      <span className="text-[10px] text-gray-400 block uppercase font-bold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyBankingPayed')}
                      </span>
                      <span className="text-lg font-bold text-red-600">
                        {renderMoneyThucThu(createOrders['rowSelected']?.payment?.tienChuyenKhoanThucTe)}
                      </span>
                    </div>

                    {showWarningTienChuyenkhoanRowSelected && (
                      <div className="mt-1 flex items-center justify-end gap-1 text-[11px] font-medium text-orange-600">
                        <span>⚠️</span>
                        <span className="text-left">
                          Thanh toán chuyển khoản nhưng chưa ghi nhận tiền chuyển khoản!
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Thông tin VAT (Nằm trên 1 hàng duy nhất) */}
            {createOrders['rowSelected']?.orderVat?.vatValue?.mst && (
              <div className="mt-2 p-1.5 bg-red-50 border border-red-200 rounded text-[12px] flex items-center space-x-3">
                <div className="font-bold text-red-600 uppercase whitespace-nowrap border-r border-red-200 pr-3">
                  VAT
                </div>
                <div className="flex flex-1 items-center space-x-4 overflow-hidden">
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">MST:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.vatValue?.mst}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="truncate max-w-[250px]">
                    <span className="font-semibold text-gray-500">Công ty:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.vatValue?.tenCongTy}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">Email:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.vatValue?.email}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="truncate flex-1">
                    <span className="font-semibold text-gray-500">Địa chỉ:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.vatValue?.address}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <h2 className="ml-1">SẢN PHẨM: </h2>
            <Table
              scroll={{ y: heigth > 899 ? 400 : 200 }}
              columns={
                createOrders['rowSelected']?.loaiDonHang == 'Nâng cấp'
                  ? columnsNC
                  : createOrders['rowSelected']?.loaiDonHang == 'Chiết khấu'
                  ? columnsCK
                  : createOrders['rowSelected']?.loaiDonHang == 'ĐL lắp giùm'
                  ? columnsDLLG
                  : createOrders['rowSelected']?.loaiDonHang == 'Trả hàng'
                  ? columnsTHang
                  : createOrders['rowSelected']?.loaiDonHang == 'Thu nợ'
                  ? columnsThuNo
                  : createOrders['rowSelected']?.loaiDonHang == 'Hàng gửi'
                  ? columnsHG
                  : createOrders['rowSelected']?.loaiDonHang == 'Thu phí'
                  ? columnsTP
                  : createOrders['rowSelected']?.loaiDonHang == 'Chênh lệch'
                  ? columnsChenhLech
                  : createOrders['rowSelected']?.loaiDonHang == 'Sửa chữa' ||
                    createOrders['rowSelected']?.loaiDonHang == 'Bảo hành'
                  ? columnsSC
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 3
                  ? columnsTLL
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 2
                  ? columnsTL
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 1
                  ? columnsTH
                  : columns
              }
              pagination={false}
              dataSource={
                createOrders['rowSelected']?.loaiDonHang == 'Sửa chữa' ||
                createOrders['rowSelected']?.loaiDonHang == 'Chênh lệch' ||
                createOrders['rowSelected']?.loaiDonHang == 'ĐL lắp giùm' ||
                createOrders['rowSelected']?.loaiDonHang == 'Trả hàng' ||
                createOrders['rowSelected']?.loaiDonHang == 'Thu nợ' ||
                createOrders['rowSelected']?.loaiDonHang == 'Bảo hành' ||
                createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' ||
                createOrders['rowSelected']?.loaiDonHang == 'Hàng gửi' ||
                createOrders['rowSelected']?.loaiDonHang == 'Chiết khấu' ||
                createOrders['rowSelected']?.loaiDonHang == 'Thu phí'
                  ? order
                  : createOrders['rowSelected']?.loaiDonHang == 'Nâng cấp'
                  ? createOrders['rowSelected']?.upgradeDetails
                  : createOrders['valueDetails']
              }
            ></Table>
          </div>
          <Divider className="" style={{ margin: 0, padding: '0px' }} />
        </>
      );
    }
  }, [chiNhanh, createOrders, fullTypeOrder, t, tagTLL, order]);

  const handleCreateOrder = async () => {
    if (isProcessing) return; // Chặn double click ở mức logic

    try {
      const bodyReq = createOrders['dataBody'] || null;
      const typeApiReq = createOrders['typeOrderAPI'] || null;
      console.log('bodyData,typeApi', createOrders, bodyReq, typeApiReq);
      if (
        bodyReq &&
        typeApiReq &&
        (uLogin?.ActionOrder?.createOrder ||
          (uLogin?.role === 'Accountant' &&
            (Number(createOrders['dataBody']?.orderTypeId) === 11 ||
              Number(createOrders['dataBody']?.orderTypeId) === 15)) ||
          Number(createOrders['dataBody']?.orderTypeId) === 13 ||
          (uLogin?.role === 'Technician' && uLogin?.isGuiHang && Number(createOrders['dataBody']?.orderTypeId) === 12))
      ) {
        setIsProcessing(true); // Bắt đầu khóa màn hình
        await OrderManagerApi.CreateNewOrder(bodyReq, typeApiReq).then(res => {
          if (!res.data.error) {
            if (createOrders['dataBody']?.maDonHangCu) {
              if (createOrders['yeuCauChinhSua'] === 1) {
                message.success(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderSuccessRequest'));
                props.callBackConfirm && props.callBackConfirm();
              } else {
                message.success(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderSuccess'));
              }
            } else {
              message.success(t('OrganizedSales.OrderManager.CreateOrder.Success'));
            }
            dispatch(updateReqReGetOrder(true));
            setTimeout(() => {
              dispatch(updateCustomerSelect(null));
              dispatch(resetState());
              dispatch(updateOpenCreateModal(false));
              dispatch(updateOpenCreateOrderModal(false));
              props.resetAllForm && props.resetAllForm();
              props.callBackCloseModal && props.callBackCloseModal();
              setIsProcessing(false);
            }, 300);
          } else {
            if (createOrders['dataBody']?.maDonHangCu) {
              message.error(
                t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderErrors') + '. ' + res.data.message,
                10
              );
            } else {
              message.error(t('OrganizedSales.OrderManager.CreateOrder.Error') + '. ' + res.data.message);
            }
            setIsProcessing(false);
          }
        });
      }
    } catch (error) {
      console.log(error);
      if (createOrders['dataBody']?.maDonHangCu) {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderErrors'));
      } else {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
      }
      setConfirmLoading(false);
    }
  };

  const handleOK = () => {
    if (
      uLogin?.ActionOrder?.createOrder ||
      uLogin?.ActionOrder?.createOrderChenhLech ||
      (uLogin?.role === 'Accountant' && Number(createOrders['dataBody']?.orderTypeId) === 11) ||
      (uLogin?.role === 'Technician' && uLogin?.isGuiHang && Number(createOrders['dataBody']?.orderTypeId) === 12)
    ) {
      handleCreateOrder();
    } else {
      message.info(t('OrganizedSales.OrderManager.CreateOrder.NotAccept'));
    }
  };

  const handleActionStaff = async (type?: TTypeStatusAPI, data?: any, typeMsg?: TTypeStatusMsg) => {
    console.log('handleActionStaff', type, data);
    if (isProcessing) return;
    try {
      setIsProcessing(true);
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.ActionStatusOrder(type, data).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          message.success(t('OrganizedSales.OrderManager.CorfirmOrder.SuccessOrder'));
          setTimeout(() => {
            dispatch(
              getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: createOrders['rowSelected']?.orderType?.id })
            );
          }, 250);
          setIsProcessing(false);
          props.resetAllForm && props.resetAllForm();
          dispatch(updateOpenCreateModal(false));
        } else if (isNeedRequestUpdateMsg(res.data.message) && rowSelected?.yeuCauChinhSua == 1) {
          setIsProcessing(false);
          message.warning(`${res.data.message}. Đơn đã gửi yêu cầu cập nhật, đang chờ người tạo đơn xác nhận`, 10);
        } else if (isNeedRequestUpdateMsg(res.data.message)) {
          // KT đổi/thêm SP mà bên tạo đơn chưa xác nhận -> hỏi KT có gửi yêu cầu cập nhật không
          setIsProcessing(false);
          confirmRequestUpdate(
            resolveRequestUpdateSource(res.data.message, rowSelected, productSetDataHaveDetails),
            async () => {
              const resReq = await OrderManagerApi.RequestOrder('YeuCauChinhSua', data.maDonHang);
              if (!resReq.data.error) {
                message.success('Đã gửi yêu cầu cập nhật đơn hàng');
                dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected?.orderType?.id }));
                dispatch(updateOpenCreateModal(false));
              } else {
                message.error(`Gửi yêu cầu cập nhật đơn hàng thất bại: ${resReq.data.message}`, 10);
              }
            }
          );
        } else {
          setIsProcessing(false);
          message.error(t('OrganizedSales.OrderManager.CorfirmOrder.FailureOrder') + '. ' + `${res.data.message}`);
        }
      });
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
      message.error(t('OrganizedSales.OrderManager.CorfirmOrder.FailureOrder'));
    } finally {
      dispatch(updatePageLoadingApi(false));
    }
  };

  const handleOK2 = () => {
    if (isProcessing) return;
    handleActionStaff(createOrders['typeStatus'], createOrders['body'], 'Completed');
  };

  return (
    <div>
      <ModalComponent
        modalTitle={
          props?.typeOrder === 'doidonhang'
            ? t('OrganizedSales.OrderManager.CorfirmOrder.Title2')
            : t('OrganizedSales.OrderManager.CorfirmOrder.Title')
        }
        modalType="confirm"
        modalSize="fit"
        visible={openCodeCreateModal}
        onOk={props?.typeOrder === 'xacnhandonhang' ? handleOK2 : handleOK}
        onCancel={handleCancel}
        confirmLoading={isProcessing}
        cancelButtonProps={{ disabled: isProcessing }}
        closable={!isProcessing}
        maskClosable={false}
      >
        <Spin spinning={isProcessing} tip="Đang xử lý, vui lòng đợi...">
          <div className="overflow-y-auto max-h-[80vh]">
            {duplicatePlateWarning} {/* ← thêm vào đây */}
            {renderListOrder}
          </div>
        </Spin>
      </ModalComponent>
    </div>
  );
}
